import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import Spine = PIXI.spine.Spine;

export class BruteForceGameAssets {

    static BITMAP_FONT_WIN_COUNT_UP: string = "winAmountfont";
    static BITMAP_NUDGE_MULTIPLIER: string = "multiplierfont";
    static BITMAP_BIGWIN_FONT: string = "bigwinfont";
    static BITMAP_BONUS_OUTRO_FONT: string = "doorfront";
    static BITMAP_WINCAP_COUNT_UP: string = "MaxwinCountUp";
    public static MAIN_GAME_BACKGROUND: string = "BG_NORMAL";


    public static ARCADE_MACHINE: string = "foreground";
    public static ARCADE_BG: string = "bg";

    public static SCREEN_LINES_TEXTURE: string = "texture2";

    public static ACTION_SPINS_BG: string = "bg_01";


    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset(BruteForceGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/winAmountfont.fnt"),
                    new BitmapFontAsset(BruteForceGameAssets.BITMAP_NUDGE_MULTIPLIER, "fonts/bitmapfonts/multiplierfont.fnt"),
                    new BitmapFontAsset(BruteForceGameAssets.BITMAP_BIGWIN_FONT, "fonts/bitmapfonts/bigwinfont.fnt"),
                    new BitmapFontAsset(BruteForceGameAssets.BITMAP_BONUS_OUTRO_FONT, "fonts/bitmapfonts/doorfront.fnt"),
                    new BitmapFontAsset(BruteForceGameAssets.BITMAP_WINCAP_COUNT_UP, "fonts/bitmapfonts/MaxwinCountUp.fnt"),
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    // new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json"),
                ],
                animations: {
                    "mainbackground": "mainBg",
                    "fsbackground": "fsbg",
                    "sfsbackground": "sfsbg",
                    "transitionmainbackground": "mainBGCopy"
                }


            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("M1", "spine/M1.json"),
                    new SpineAsset("M2", "spine/M2.json"),
                    new SpineAsset("M3", "spine/M3.json"),
                    new SpineAsset("M4", "spine/M4.json"),
                    new SpineAsset("M5", "spine/M5.json"),
                    new SpineAsset("L1", "spine/L1.json"),
                    new SpineAsset("L2", "spine/L2.json"),
                    new SpineAsset("L3", "spine/L3.json"),
                    new SpineAsset("L4", "spine/L4.json"),
                    new SpineAsset("L5", "spine/L5.json"),
                    new SpineAsset("SC", "spine/SC.json"),
                    new SpineAsset("XN_1", "spine/XN_1.json"),
                    new SpineAsset("XN_2", "spine/XN_2.json"),
                    new SpineAsset("XN_3", "spine/XN_3.json"),
                    new SpineAsset("Transition_Shutter", "spine/transition.json"),
                    new SpineAsset("WinHighlight", "spine/highlight.json"),
                    new SpineAsset("NudgeMeterSpine", "spine/nudge_meter.json"),
                    new SpineAsset("NudgeReelHighlight", "spine/nudge_highlight.json"),
                    new SpineAsset("NudgeLock", "spine/Nudge_Lock.json"),
                    new SpineAsset("arcadeMachine", "spine/BG.json"),
                    new SpineAsset("nudgeCounterScreen", "spine/nudge_counter.json"),
                    new SpineAsset("BW1", "spine/bw_1.json"),
                    new SpineAsset("BW2", "spine/bw_2.json"),
                    new SpineAsset("BW3", "spine/bw_3.json"),
                    new SpineAsset("BW4", "spine/bw_4.json"),
                    new SpineAsset("BW5", "spine/bw_5.json"),
                    new SpineAsset("maxWinText", "spine/maxwin_text.json"),
                    new SpineAsset("crackedGlass", "spine/maxwin_crack.json"),
                    new SpineAsset("bonusIntroText", "spine/bruteSpins.json"),
                    new SpineAsset("glitchScreen", "spine/Glitch_Screen.json"),
                    new SpineAsset("nudgeGlowStates","spine/nudge_meter_glow.json")
                ]
            },
            {
                name: "main",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),


                ],
                animations: {

                    "BW_text_1": "BW/text/bw_01",
                    "BW_text_2": "BW/text/bw_02",
                    "BW_text_3": "BW/text/bw_03",
                    "BW_text_4": "BW/text/bw_04",
                    "BW_text_5": "BW/text/bw_05",
                    "BW_stamp_1": "BW/stamp/bw_01",
                    "BW_stamp_2": "BW/stamp/bw_02",
                    "BW_stamp_3": "BW/stamp/bw_03",
                    "BW_stamp_4": "BW/stamp/bw_04",
                    "BW_stamp_5": "BW/stamp/bw_05",
                    "highlight": "Highlight",
                    "bruteSpinsLogo": "brute_spins",
                    "superBruteSpinsLogo": "superbrute_spins",
                    "team_member1": "team_members/member1",
                    "team_member2": "team_members/member2",
                    "team_member3": "team_members/member3",
                    "team_member4": "team_members/member4",
                    "team_member5": "team_members/member5",
                    "team_member6": "team_members/member6",
                    "team_member7": "team_members/member7",
                    "team_member8": "team_members/member8",
                    "team_member9": "team_members/member9",
                    "team_member10": "team_members/member10",
                    "team_member11": "team_members/member11",
                    "credits_frame": "frame",
                    "tenSpinsWonNoImg": "10",
                    "member2": "team_members/member2",
                    "meterNeedle": "nudge_meter/meter_hand",
                    "nudgeSparksEffect": "Nudge_Sparks/Nudge_Sparks_",
                    "nudgeFireHighlight": "XN_WinHighlight/XN_WinHighlight_",
                    "coinGold": "BW_particles/coinGold/coinGold_",
                    "coinSilver": "BW_particles/coinSilver/coinSilver_",
                    "bullet": "BW_particles/bullet/",
                    "grenade": "BW_particles/grenade/",
                    "nudgeCounterPortrait": "counter_02",
                    "nudgeCounterDesktop": "counter_01",
                    "mainFG": "bgFront/mainFg",
                    "gameOverText": "wincap/game-over",
                    "spinBG": "spinBG",
                    "scatterTease": "Scatter_Tease/Scatter_Tease_",
                    "easterEgg": "eastereggImg",
                    "redButtonUp": "button/button_up_0",
                    "yellowButtonUp": "button/button_up_1",
                    "blueButtonUp": "button/button_up_2",
                    "redButtonDown": "button/button_down_0",
                    "yellowButtonDown": "button/button_down_1",
                    "blueButtonDown": "button/button_down_2",
                    "pole": "pole_01",
                    "pipe": "pole_02",
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),


                ],
                animations: {
                    "betline_1": "betline/betline1/betline1_",
                    "betline_2": "betline/betline2/betline2_",
                    "betline_3": "betline/betline3/betline3_",
                    "betline_4": "betline/betline4/betline4_",
                    "scatterAnticipation": "anticipation/anticipation_",
                    "boosterAnticipation": "Booster_Anticipation/Booster_Anticipation_",
                    "xBetReelAttention": "xBetReelAttention",
                    "xBetReelAttention2": "xBetReelAttention2",
                    "startGlitch": "Glitch/Glitch_",
                    "BW_1": "BW/bigwin1",
                    "BW_2": "BW/bigwin2",
                    "BW_3": "BW/bigwin3",
                    "BW_4": "BW/bigwin4",
                    "BW_5": "BW/bigwin5",
                    "gameOverTextBottomGlow": "glow",
                    "nudgeCounterScreenSparks": "nudgeCounter_Highlight/nudgeCounter_Highlight_",
                    "reelDropBlast": "Nudge_Sparkswave/Nudge_Sparkswave_",
                    "nudgeMutliGlow": "nudgeglow",
                    "nudgeMultiLines": "lines",
                    "nudgeMultiFlyTrail": "trail"

                }
            },

            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json"),

                ],
                animations: {
                    "nudgeLogo": "XN_1/Xnudge_01"
                }
            }
        ]
    };
}